import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CustomerService } from 'src/app/services/customer.service';
import { CustomerImportDialogComponent } from './customer-import.dialog';

@Injectable({
  providedIn: 'root'
})
export class CustomerImportDialogService {

    constructor(public dialog: MatDialog) {}

    public open(callback: any) {
        let dialog = this.dialog.open(CustomerImportDialogComponent, {
            width: '800px',
            data: {}
        });

        dialog.afterClosed().subscribe(r => {
            callback();
        })
    }
}
